
import React, { useState, useRef, useEffect } from "react";
import Input from "../../../../../Components/Input";
import DateInput from "../../../../../Components/DateInput";
import TextInput from '../../../../../Components/TextInput'
import search from '../../../../../Assets/Icons/search.png';
import Dropdown from "../../../../../Components/Dropdown";
import MobileInput from "../../../../../Components/MobileInput";
import editIcon from '../../../../../Assets/Icons/edit.png'
import deleteIcon from '../../../../../Assets/Icons/delete.png';
import filterIcon from '../../../../../Assets/Icons/filter.png'
import leftBtuIcon from '../../../../../Assets/Icons/back.png'
import SMSLogsListController from "../../../../Controllers/AdminScreens/Configuration/ActivityRegister/SMSLogsListController";
import ConfigurationAddNewContactModal from "../../../../../Components/Modals/ConfigurationAddNewContactModal";
import { convertGMTToLocal } from "../../../../../Utils/Validation";
import Loader from "../../../../../Components/Loader";
import downArrow from '../../../../../Assets/Icons/chevron-down.png';
import { getLocalDateTime } from '../../../../../Utils/Validation';




const SMSLogsList = ({ smsLogLoading,
  setSmsLogLoading,
  smsLogError,
  setSmsLogError,
  smsLogList,
  setSmsLogList,
  onRefresh,
  userLoading, userError, recipientOptions, contactListLoading, contactListError, contactListList }) => {

  const {
    handleInputChange,
    sentBy,
    setSentBy, currentPage,
    handlePageChange,
    totalPages,
    currentSmsLogList,
    selectList,
    setSelectList,
    setDate,
    date,
    clientList,
    setClientList,
    error, setError,
    searchUser, setSearchUser,
    selectedClientError, setSelectedClientError,
    selectedClients, setSelectedClients,
    loading, setLoading,
    handleSearchInputText,
    handleSearchClient,
    handleSelectClient,
    selectedClient, setSelectedClient,
    smsLogFilter, setSmsLogFilter,
    smsLogFilterLoading, setSmsLogFilterLoading,
    smsLogFilterError, setSmsLogFilterError, fetchsmsLogFilter,
    filterError,
    showFilters,
    setShowFilters,
    resetFilters,
    cancelFilters,
    expandedRows,
    toggleExpand,
    setExpandedRows,
  } = SMSLogsListController({
    smsLogLoading,
    setSmsLogLoading,
    smsLogError,
    setSmsLogError,
    smsLogList,
    setSmsLogList,
    onRefresh
  });

  const toggleFilters = () => {
    setShowFilters((prev) => !prev); // Toggle the filter visibility
  };

  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
    setExpandedRows({});
  };

  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddNewContact = () => {
    setIsModalOpen(true); // Open the modal
  };


  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [showToggleMap, setShowToggleMap] = useState({});
  const contentRefs = useRef({});

  useEffect(() => {
    const map = {};
    setTimeout(() => {
      smsLogFilter.forEach((_, index) => {
        const ref = contentRefs.current[index];
        if (ref && ref.scrollHeight > ref.clientHeight) {
          map[index] = true;
        }
      });
      setShowToggleMap(map);
    }, 50); // wait for DOM paint
  }, [smsLogFilter, expandedRows]);


  return (
    <>
      <div className='basic-info-container'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={styles.categoryHeader}>SMS Logs</h3>
          {/* <div style={{display:'flex', marginBottom:'10px'}}>
            <button className="add-client-button" style={{ paddingLeft: 30, paddingRight: 30, marginRight:'15px' }} onClick={handleAddNewContact}>
              Add Contact
            </button>
            <button className="cancel-button" style={{ border: '1px #40513B solid', borderRadius: '20px', paddingLeft:'30px', paddingRight:'30px' }} onClick={handleAddNewContact}>
              Upload Contacts
            </button>
          </div> */}
        </div>
        <div style={styles.container}>
          <div style={styles.filtersHeader}>
            <button style={styles.filterButton} onClick={toggleFilters}> <img src={filterIcon} style={styles.filterIcon} /> Filters</button>
            <div>
              <img src={leftBtuIcon} style={{ marginRight: '5px', cursor: 'pointer', width: '28px', height: '28px' }} />
              <img src={leftBtuIcon} style={{ transform: 'rotate(180deg)', transition: 'transform 0.3s ease', cursor: 'pointer', width: '28px', height: '28px' }} />
            </div>
          </div>
        </div>
        {/* Filters using Flexbox */}
        {showFilters && (
          <div className={`tasksScreen-filters-container ${showFilters ? 'tasksScreen-open-filters' : ''}`}>
            <div className="tasksScreen-filters">
              <Dropdown
                ref={(el) => (dropdownRefs.current["selectList"] = el)}
                isOpen={openDropdown === "selectList"}
                toggleDropdown={() => toggleDropdown("selectList")}
                label="Sent To"
                options={contactListList || []}
                value={selectList}
                onChange={(selected) => {
                  setSelectList(selected);
                  // if (selected?.value) {
                  //   fetchContact(selected.value);
                  // }
                }}
                errorMessage={contactListError}
                loading={contactListLoading}
              // searchBoxWidth={190}
              />

              <div >
                <label style={{ ...styles.labelStyle, display: "block" }}>Date</label>
                <DateInput
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div className="filter-field" style={{ width: '-webkit-fill-available' }}>
                <label style={{ ...styles.labelStyle, display: "block" }}>
                  Select Client
                </label>
                <TextInput
                  label="Select Client"
                  type="text"
                  placeholder="Search"
                  style={{ padding: "20px 10px" }}
                  value={searchUser}
                  onChange={(e) => handleSearchInputText(e.target.value)}
                  onRightClick={handleSearchClient}
                  right={
                    loading ? (
                      <Loader loading={loading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                    ) : (
                      <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                    )
                  }
                  errorMessage={error}
                  width={280}
                />
                {clientList.length > 0 && (
                  <ul style={styles.dropdownList}>
                    {clientList.map((client, index) => (
                      <li
                        key={client?.client_id}
                        onClick={() => handleSelectClient(client)}
                        style={{
                          ...styles.dropdownItem,
                          borderBottom: index !== clientList.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                        }}
                      >
                        {client?.client_name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <Dropdown
                ref={(el) => (dropdownRefs.current["Sent By"] = el)}
                isOpen={openDropdown === "Sent By"}
                toggleDropdown={() => toggleDropdown("Sent By")}
                label="Sent By"
                options={recipientOptions || []}
                placeholder="------"
                value={sentBy}
                onChange={(value) => setSentBy(value)}
                loading={userLoading}
                errorMessage={userError}
              />
            </div>
            <div>
              {filterError && <div className="list-error-msg" style={{ textAlign: 'left', paddingBottom: 5 }}> {filterError}</div>}
              <div className="tasksScreen-filter-buttons" style={{ marginBottom: '15px' }}>
                <button className="tasksScreen-apply-button" style={{ cursor: smsLogFilterLoading ? 'not-allowed' : 'pointer', opacity: smsLogFilterLoading ? 0.5 : 1 }} disabled={smsLogFilterLoading} onClick={fetchsmsLogFilter}>Apply</button>
                <button className="cancel-button" style={{ border: '1px var(--button-bg-color) solid', borderRadius: '20px' }} onClick={cancelFilters}>Cancel</button>
                <button className="cancel-button" onClick={resetFilters}>Reset</button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className='basic-info-card' style={{ border: 'none', padding: '0px' }}>
        <div style={styles.tableWrapper}>
          <table className="tasksScreen-task-table">
            <thead>
              <tr>
                <th style={{ width: "10%" }}>Date</th>
                <th style={{ width: "50%" }}>Message Content</th>
                <th style={{ width: "30%" }}>Sent To</th>
                <th style={{ width: "10%" }}>Sent By</th>
                {/* <th style={{ width: "15%" }}>Added By</th>
                <th style={{ width: "10%" }}>Opt Out</th>
                <th style={{ width: "5%" }}></th> */}
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "white" }}>
              {smsLogFilter?.map((category, index) => (
                <tr key={index}>
                  <td style={styles.tableValue}>{category?.sent_date ? convertGMTToLocal(category?.sent_date, 'dd/MM/yyyy') : '--'}</td>
                  <td style={styles.tableValue}>
                    {category?.template_text ? (
                      <>
                        <div
                          ref={(el) => (contentRefs.current[index] = el)}
                          style={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: expandedRows[`${index}-template_text`] ? "unset" : 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxHeight: expandedRows[`${index}-template_text`] ? "none" : "20px", // adjust based on font-size/line-height
                            lineHeight: "20px", // ensure consistent height for clamp
                            whiteSpace: "normal", // avoid forcing nowrap if using clamp
                          }}
                          dangerouslySetInnerHTML={{ __html: category?.template_text }}
                        />
                        {(showToggleMap[index] || expandedRows[`${index}-template_text`]) && (
                          <span
                            className="show-more-less"
                            onClick={() => toggleExpand(`${index}-template_text`)}
                            style={{ color: "#5A55D2", cursor: "pointer" }}
                          >
                            {expandedRows[`${index}-template_text`] ? "Less" : "More"}
                          </span>
                        )}
                      </>
                    ) : (
                      "--"
                    )}
                  </td>
                  <td style={styles.tableValue}>{category?.sent_to || '--'}</td>
                  <td style={styles.tableValue}>{category?.sent_by_name}</td>
                  {/* <td style={styles.tableValue}>{category.addedBy}</td>
                  <td style={styles.tableValue}>{category.optOut}</td> */}
                  {/* <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "2px", 
                      }}
                    >
                     
                      <button
                        className="tasksScreen-edit-button"
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={editIcon}
                          alt="Edit"
                          style={{ width: "16px", height: "16px" }}
                        onClick={handleAddNewContact}
                        />
                      </button>

                      
                      <button
                        className="tasksScreen-delete-button"
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={deleteIcon}
                          alt="Delete"
                          style={{ width: "16px", height: "16px" }}
                        />
                      </button>
                    </div>
                  </td> */}

                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {isModalOpen && (
          <ConfigurationAddNewContactModal isOpen={isModalOpen} onClose={handleCloseModal} />
        )}
        {smsLogFilterLoading && <Loader loading={smsLogFilterLoading} color={'var(--primary-loader-color)'} />}
        {smsLogFilterError && <div className="list-error-msg">{smsLogFilterError} </div>}
        <div className="tasksScreen-table-footer">
          <span className="tasksScreen-pagination-info">
            {`${currentPage}-${totalPages} of items`}
          </span>
          <div className="tasksScreen-pagination">
            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
              <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
            </button>

            {visiblePages.map((page) => (
              <button key={page} className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
                {page}
              </button>
            ))}

            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
              <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
            </button>
          </div>
        </div>
      </div>
      {/* <hr className="divider" style={{ marginTop: '20px' }} /> */}
    </>
  )

}

const styles = {
  categoryHeader: {
    color: '#1F384C',
    fontSize: 18,
    fontFamily: 'Roboto Slab',
    fontWeight: 500,
    paddingBottom: 20
  },
  tableWrapper: {
    overflowX: "auto", // Horizontal scroll
    whiteSpace: "nowrap", // Prevent table from wrapping on small devices
    // marginBottom:50
  },
  tableValue: {
    colour: '#192A3E',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px'
  },
  tableLink: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    textDecoration: 'underline',
    color: '#5A55D2'
  },
  container: {
    padding: "5px",
    backgroundColor: "#EFF0F4",
    border: "none",
    // borderRadius: "5px",
    border: '1px #EFF0F4 solid'
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "15px",
  },
  filterButton: {
    backgroundColor: "white",
    color: "var(--button-bg-color)",
    border: "none",
    borderRadius: "5px",
    padding: "5px 8px",
    cursor: "pointer",
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    border: '1px var(--button-bg-color) solid'

  },
  filterIcon: {
    width: '10px',
    height: '10px',
    paddingRight: '5px'
  },

  paginationButtons: {
    display: "flex",
    gap: "5px",
  },
  paginationButton: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  filtersContainer: {
    // display: "flex",
    flexWrap: "wrap", // Wrap inputs to the next line if needed
    gap: "20px", // Space between inputs
    marginBottom: "15px",
    // justifyContent: "space-between", // Distribute inputs evenly
    border: '1px #EFF0F4 solid',
    padding: '10px'
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  applyButton: {
    backgroundColor: "var(--button-bg-color)",
    color: "var(--button-text-color)",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  resetButton: {
    backgroundColor: "transparent",
    color: "#555",
    border: "none",
    cursor: "pointer",
  },
  labaleStyle: {
    fontSize: '12px',
    // marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },
  labelStyle: {
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "Roboto",
    color: "rgb(52, 60, 68)",
  },


}

export default SMSLogsList